import React from "react";
import { Row, Col, Spinner, Alert } from "reactstrap";
import useManagerDashboard from "./hooks/useManagerDashboard";
import StatCardAdvance from "./components/StatCardAdvance";
import ActivityChart from "./components/charts/ActivityChart";
import RenewalChart from "./components/charts/RenewalChart";
import OccupancyChart from "./components/charts/OccupancyChart";
import GrowthChart from "./components/charts/GrowthChart";


const ManagerDashboard = () => {
    const { loading, error, data } = useManagerDashboard();

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner color="primary" />
                <p className="text-muted mt-2">Carregando métricas...</p>
            </div>
        );
    }

    if (error) {
        return (
            <Alert color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>
                Erro ao carregar métricas: {error}
            </Alert>
        );
    }


    return (
        <React.Fragment>
            <div className="d-flex justify-content-end align-items-center pt-2 mb-3">
            </div>

            {/* ── Cards Unificados ── */}
            <Row className="align-items-stretch">
                <Col md={4} sm={6} className="mb-3">
                    <StatCardAdvance
                        title="Alunos Ativos"
                        currentValue={data.activeMembers}
                        previousValue={data.previousActiveMembers}
                        subtitle="Hoje"
                        icon="mdi mdi-account-check-outline"
                    />
                </Col>
                <Col md={4} sm={6} className="mb-3">
                    <StatCardAdvance
                        title="Novos Alunos"
                        currentValue={data.newMembersMonth}
                        previousValue={data.previousNewMembersMonth}
                        subtitle={`Hoje: ${data.newMembersToday}`}
                        icon="mdi mdi-account-star-outline"
                    />
                </Col>
                <Col md={4} sm={6} className="mb-3">
                    <StatCardAdvance
                        title="Renovações"
                        currentValue={data.renewalsMonth}
                        previousValue={data.previousRenewalsMonth}
                        subtitle={`Hoje: ${data.renewalsToday}`}
                        icon="mdi mdi-autorenew"
                    />
                </Col>
                <Col md={4} sm={6} className="mb-3">
                    <StatCardAdvance
                        title="Retornos"
                        currentValue={data.returnsMonth}
                        previousValue={data.previousReturnsMonth}
                        subtitle={`Hoje: ${data.returnsToday}`}
                        icon="mdi mdi-account-arrow-left-outline"
                    />
                </Col>
                <Col md={4} sm={6} className="mb-3">
                    <StatCardAdvance
                        title="Cancelamentos"
                        currentValue={data.cancellationsMonth || 0}
                        previousValue={data.previousCancellationsMonth || 0}
                        subtitle="Mês atual"
                        icon="mdi mdi-account-cancel-outline"
                    />
                </Col>
                <Col md={4} sm={6} className="mb-3">
                    <StatCardAdvance
                        title="Churn"
                        currentValue={data.churnRate || 0}
                        previousValue={data.previousChurnRate || 0}
                        subtitle="Índice de evasão"
                        icon="mdi mdi-account-alert-outline"
                        isPercentage={true}
                    />
                </Col>
            </Row>


            <Row className="align-items-stretch mb-4">
                <Col md={6} className="mb-4 mb-md-0">
                    <ActivityChart data={data.activityChartData} />
                </Col>
                <Col md={6}>
                    <RenewalChart data={data.renewalChartData} />
                </Col>
            </Row>

            <Row className="align-items-stretch">
                <Col md={7} className="mb-4">
                    <OccupancyChart data={data.occupancy} />
                </Col>
                <Col md={5} className="mb-4">
                    <GrowthChart data={data.growthChartData} ticketMedio={data.ticketMedio} activeMembers={data.activeMembers} />
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default ManagerDashboard;
